import { Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { usersApi } from '../../services/api';
import Header from './Header';
import Navigation from './Navigation';

export default function Layout() {
  const { data: meData } = useQuery({
    queryKey: ['me'],
    queryFn: () => usersApi.me(),
    staleTime: 5 * 60 * 1000,
  });

  const currentUser = meData?.data;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <Header user={currentUser} />

      {/* Main content */}
      <main className="flex-1 max-w-2xl mx-auto w-full px-4 pb-24 pt-4">
        <Outlet />
      </main>

      {/* Bottom navigation (mobile) */}
      <Navigation />
    </div>
  );
}
